export default __webpack_public_path__ + "static/media/AmericanDreamers_productions.712e1a29.jpg";